export const useDialog = () => {
  const { $eventBus } = useNuxtApp()

  const alert = (option: Partial<IEventBusDialogAlert>) => {
    const defaultOption: IEventBusDialogAlert = {
      title: '',
      message: '',
      buttonText: {
        confirm: '확인',
      },
      onConfirm: () => {},
    }
    $eventBus?.emit<'dialog:alert'>(
      'dialog:alert',
      merge(defaultOption, option),
    )
  }

  /**
   * @description route 변경시 TheDialoClose 처리
   */
  const forceCloseAllTheDialog = () => {
    $eventBus?.emit<'dialog:close'>('dialog:close')
  }

  const confirm = (option: Partial<IEventBusDialogConfirm>) => {
    const defaultOption: IEventBusDialogConfirm = {
      title: '',
      message: '',
      buttonText: {
        confirm: '확인',
        cancel: '취소',
      },
      onConfirm: () => {},
      onCancel: () => {},
    }
    $eventBus?.emit<'dialog:confirm'>(
      'dialog:confirm',
      merge(defaultOption, option),
    )
  }

  const confirmAsync = async (
    option: Partial<IEventBusDialogConfirmAsync>,
  ): Promise<void> => {
    return await new Promise((resolve, reject) => {
      const defaultOption: IEventBusDialogConfirmAsync = {
        title: '',
        message: '',
        buttonText: {
          confirm: '확인',
          cancel: '취소',
        },
      }
      const mergedOption = merge(defaultOption, option)
      $eventBus?.emit('dialog:confirm', {
        ...mergedOption,
        onConfirm: () => {
          resolve()
        },
        onCancel: () => {
          // todo exception처리 추가 필요
          reject(new Error())
        },
      })
    })
  }

  return {
    alert,
    confirm,
    confirmAsync,
    forceCloseAllTheDialog,
  }
}
